var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"wrapper"},[_c('Nav'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Footer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }